import { render, staticRenderFns } from "./AcceptedUser.vue?vue&type=template&id=5a544a72&scoped=true&"
import script from "./AcceptedUser.vue?vue&type=script&lang=js&"
export * from "./AcceptedUser.vue?vue&type=script&lang=js&"
import style0 from "./AcceptedUser.vue?vue&type=style&index=0&id=5a544a72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a544a72",
  null
  
)

export default component.exports